export default "__VITE_ASSET__d92b320a__"